
(() => {
    document.addEventListener("DOMContentLoaded", function () {
        var llws = new LibraryLinkWebService();
    });
})();

export class LibraryLinkWebService {

    private _initialised: boolean = false;
    private _element: JQuery<HTMLElement>;
    private _loadingIndicator: JQuery<HTMLElement>;
    private _xgkey: string;
    private _xgtype: string;
    private _controllerRoute: string;
    private _action: string;   
    
    constructor(
        private _contentId = "llwsContent",
        private _loaderId = "llwsLoader"
    ) {
        this.init();
    }

    private init = () => {
        if (this._initialised) {
            return;
        }
        this._element = $(`#${this._contentId}`);
        this._loadingIndicator = $(`#${this._loaderId}`);
        this._xgkey = this._element.data("xgkey");
        this._xgtype = this._element.data("xgtype");
        this._controllerRoute = this._element.data("route");
        this._action = this._element.data("action");           

        this.LoadLlwsData();
        this._initialised = true;
    }

    private LoadLlwsData = (): void => {
        let self = this;
        self._loadingIndicator.show();       
        self._element.load(`/${self._controllerRoute}/${self._action}/${self._xgtype}/${self._xgkey}`, function (response, status, xhr) {
            //if (status == "error") {
            //    var msg = "Sorry but there was an error loading the library link images: ";
            //    $("#error").html(msg + xhr.status + " " + xhr.statusText);
            //}
            self._loadingIndicator.hide();
        });
    }

}



// WEBPACK FOOTER //
// ./Scripts/LibraryLinkWebService.ts